import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

export const adminUserReplacementService = {
  addUserReplacement: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user-replacements/add`,
        payload,
        getAxiosOptions(user),
      )
    ).data
  },

  getUserReplacement: async (user) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/user-replacements/get-user-replacements`,
        getAxiosOptions(user),
      )
    ).data
  },

  updateUserReplacement: async (user, payload) => {
    return (
      await axios.put(
        `${NODE_BASE_URL}/admin/user-replacements/update/${payload.id}`,
        payload,
        getAxiosOptions(user),
      )
    ).data
  },

  previewDeactivateUserReplacement: async (user, id) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/user-replacements/deactivate-preview/${id}`,
        getAxiosOptions(user),
      )
    ).data
  },

  deactivateUserReplacement: async (user, id) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user-replacements/deactivate/${id}`,
        {},
        getAxiosOptions(user),
      )
    ).data
  },

  addUserReplacementLog: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user-replacements/add-log`,
        payload,
        getAxiosOptions(user),
      )
    ).data
  },

  getUserReplacementLogs: async (user) => {
    return (
      await axios.get(`${NODE_BASE_URL}/admin/user-replacements/get-logs`, getAxiosOptions(user))
    ).data
  },

  previewTasks: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user-replacements/preview-tasks`,
        payload,
        getAxiosOptions(user),
      )
    ).data
  },

  applyTasks: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user-replacements/apply-tasks`,
        payload,
        getAxiosOptions(user),
      )
    ).data
  },
}
